module.exports = __webpack_public_path__ + "static/media/compress-alt.caf9b27c.svg";